module.exports = __webpack_public_path__ + "files/e03408ba13ef8bae906c15e393761ab7.png";